import { Col, type ColProps } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import InputField from '../../../../components/fields/InputField';
import PasswordField from '../../../../components/fields/PasswordField';

const defaultColSpan = { lg: 8, md: 12, xs: 24 };

export type BmwFsBankIntegrationProps = {
    prefix?: string;
    colSpan?: ColProps;
    isUpdate: boolean;
    disabled?: boolean;
};

const fieldNames = ['host', 'accessKey', 'secretKey', 'dealerCode'] as const;

const BmwFsBankIntegration = ({
    prefix,
    colSpan = defaultColSpan,
    isUpdate,
    disabled = false,
}: BmwFsBankIntegrationProps) => {
    const { t } = useTranslation(['bankDetails']);

    const names = useMemo(
        () =>
            Object.fromEntries(fieldNames.map(name => [name, prefix ? `${prefix}.${name}` : name])) as Record<
                (typeof fieldNames)[number],
                string
            >,
        [prefix]
    );

    return (
        <>
            <Col {...colSpan}>
                <InputField
                    {...t('bankDetails:fields.bmwFsIntegration.host', { returnObjects: true })}
                    addonBefore="https://"
                    disabled={disabled}
                    name={names.host}
                    required
                />
            </Col>
            <Col {...colSpan}>
                <InputField
                    {...t('bankDetails:fields.bmwFsIntegration.accessKey', { returnObjects: true })}
                    disabled={disabled}
                    name={names.accessKey}
                    required
                />
            </Col>
            <Col {...colSpan}>
                <PasswordField
                    {...t('bankDetails:fields.bmwFsIntegration.secretKey', { returnObjects: true })}
                    disabled={disabled}
                    name={names.secretKey}
                    placeholder="•••••"
                    required={!isUpdate}
                />
            </Col>
            <Col {...colSpan}>
                <InputField
                    {...t('bankDetails:fields.bankIntegration.dealerCodeForAudiAndSDM', { returnObjects: true })}
                    disabled={disabled}
                    name={names.dealerCode}
                />
            </Col>
        </>
    );
};

export default BmwFsBankIntegration;
